import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private _spinnerActive$ = new BehaviorSubject<boolean>(false);
  private _gridSpinnerActive$ = new BehaviorSubject<boolean>(false);

  public get spinnerActive$(): Observable<boolean> {
    return this._spinnerActive$.asObservable();
  }

  public get gridSpinnerActive$(): Observable<boolean> {
    return this._gridSpinnerActive$.asObservable();
  }

  public setSpinnerState(state: boolean) {
    this._spinnerActive$.next(state);
  }

  public setGridSpinnerState(state: boolean) {
    this._gridSpinnerActive$.next(state);
  }
}
